import React from "react";
type InstagramIconProps = {
  className?: string;
};
export function InstagramIcon({
  className = ""
}: InstagramIconProps) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-166" data-mp="3ugi5cc8iaeiu">
      <rect x="2" y="2" width="20" height="20" rx="5" data-id="element-167" data-mp="76to5eo6ak1o" />
      <circle cx="12" cy="12" r="4" data-id="element-168" data-mp="36l5rok0e89y9" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-169" data-mp="36m768ygmbekq" />
    </svg>;
}